
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Chats() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  
  const [chats] = useState([
    {
      id: 1,
      name: 'سارة أحمد',
      lastMessage: 'هل وصلت إلى المطار؟',
      time: '10:30 ص',
      unread: 2,
      online: true,
      flight: 'SV123',
      avatar: 'https://public.readdy.ai/ai/img_res/6cabddd52704917b0dea7fe126a08cee.jpg'
    },
    {
      id: 2,
      name: 'محمد علي',
      lastMessage: 'نعم، سأكون هناك في الوقت المحدد',
      time: '9:45 ص',
      unread: 0,
      online: true,
      flight: 'SV123',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20man%20in%20business%20attire%2C%20friendly%20confident%20smile%2C%20realistic%20portrait%20photography%2C%20clean%20modern%20background%2C%20natural%20lighting&width=60&height=60&seq=5&orientation=squarish'
    },
    {
      id: 3,
      name: 'فاطمة محمد',
      lastMessage: 'شكراً لك على المساعدة',
      time: 'أمس',
      unread: 0,
      online: false,
      flight: 'MS456',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20woman%20with%20hijab%2C%20kind%20expression%2C%20realistic%20portrait%20photography%2C%20soft%20lighting%2C%20office%20background%2C%20professional%20attire&width=60&height=60&seq=6&orientation=squarish'
    },
    {
      id: 4,
      name: 'عبدالله السعود',
      lastMessage: 'هل يمكننا مشاركة التاكسي؟',
      time: 'أمس',
      unread: 1,
      online: false,
      flight: 'EK789',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20man%20with%20traditional%20dress%2C%20warm%20smile%2C%20realistic%20portrait%20photography%2C%20natural%20lighting%2C%20modern%20office%20background&width=60&height=60&seq=7&orientation=squarish'
    },
    {
      id: 5,
      name: 'نورا خالد',
      lastMessage: 'تم إرسال معلومات الرحلة',
      time: 'الأربعاء',
      unread: 0,
      online: true,
      flight: 'SV123',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20woman%20in%20business%20casual%2C%20confident%20smile%2C%20realistic%20portrait%20photography%2C%20natural%20lighting%2C%20clean%20background&width=60&height=60&seq=8&orientation=squarish'
    }
  ]);

  const tabs = [
    { id: 'all', label: 'الكل', count: chats.length },
    { id: 'unread', label: 'غير مقروءة', count: chats.filter(c => c.unread > 0).length },
    { id: 'online', label: 'متصل', count: chats.filter(c => c.online).length }
  ];

  const filteredChats = chats.filter(chat => {
    const matchesSearch = chat.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         chat.flight.toLowerCase().includes(searchTerm.toLowerCase());
    
    if (activeTab === 'unread') return matchesSearch && chat.unread > 0;
    if (activeTab === 'online') return matchesSearch && chat.online;
    return matchesSearch;
  });

  const totalUnread = chats.reduce((sum, chat) => sum + chat.unread, 0);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 pt-12 pb-4 px-6">
        <div className="flex items-center justify-between mb-4">
          <button 
            onClick={() => navigate('/main')}
            className="w-10 h-10 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-xl text-gray-600"></i>
          </button>
          
          <div className="text-center">
            <h1 className="text-lg font-bold text-gray-800 font-arabic">المحادثات</h1>
            {totalUnread > 0 && (
              <span className="text-sm text-blue-600 font-arabic">{totalUnread} رسائل جديدة</span>
            )}
          </div>
          
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-add-line text-xl text-gray-600"></i>
          </button>
        </div>

        {/* Search Bar */}
        <div className="relative mb-4">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="البحث في المحادثات..."
            className="w-full p-3 pr-10 bg-gray-100 rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-right font-arabic"
          />
          <i className="ri-search-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
        </div>

        {/* Tabs */}
        <div className="flex space-x-1 space-x-reverse bg-gray-100 rounded-lg p-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 py-2 px-4 rounded-md text-sm font-arabic transition-all duration-200 ${
                activeTab === tab.id
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className={`mr-1 px-2 py-0.5 rounded-full text-xs ${
                  activeTab === tab.id ? 'bg-blue-100' : 'bg-gray-200'
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Chat List */}
      <div className="px-6 py-4">
        {filteredChats.length > 0 ? (
          <div className="space-y-2">
            {filteredChats.map((chat) => (
              <button
                key={chat.id}
                onClick={() => navigate(`/chat/${chat.id}`)}
                className="w-full bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300 text-right"
              >
                <div className="flex items-center space-x-3 space-x-reverse">
                  <div className="relative">
                    <img 
                      src={chat.avatar} 
                      alt={chat.name} 
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    {chat.online && (
                      <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                    )}
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-1">
                      <div className="flex items-center space-x-2 space-x-reverse">
                        <h3 className="font-bold text-gray-800 font-arabic">{chat.name}</h3>
                        <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full font-arabic">
                          {chat.flight}
                        </span>
                      </div>
                      <span className="text-xs text-gray-500 font-arabic">{chat.time}</span>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <p className="text-gray-600 text-sm font-arabic truncate max-w-48">
                        {chat.lastMessage}
                      </p>
                      {chat.unread > 0 && (
                        <div className="bg-blue-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                          {chat.unread}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-chat-3-line text-2xl text-gray-400"></i>
            </div>
            <p className="text-gray-500 font-arabic">لا توجد محادثات</p>
            <p className="text-gray-400 text-sm font-arabic mt-1">ابدأ محادثة جديدة مع الركاب</p>
          </div>
        )}
      </div>

      {/* FAB */}
      <button 
        onClick={() => navigate('/new-chat')}
        className="fixed bottom-20 left-6 w-14 h-14 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center"
      >
        <i className="ri-add-line text-xl"></i>
      </button>

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}